import React from 'react';
import styled from 'styled-components';
import { getFieldValue, RichText } from '@sitecore-jss/sitecore-jss-react';
import { Button } from 'components/components/atoms';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import breakpoints from 'utils/breakpoints';

const Container = styled.div`
  ${({ isMobile }) => isMobile && 'margin-top: 7.188rem;'};
`;

const Heading = styled.div`
  letter-spacing: -0.5px;
  line-height: 2.625rem;
  max-width: 20.625rem;
  @media ${breakpoints.md} {
    max-width: 40rem;
    line-height: 4.375rem;
    margin-bottom: 0.55rem;
  }
`;

const Text = styled.div`
  max-width: 19.5rem;
  letter-spacing: 0.14px;
  @media ${breakpoints.md} {
    max-width: 42.5rem;
  }
`;

const PageNotFound = ({ fields }) => {
  const headline = getFieldValue(fields, 'headline');
  const text = getFieldValue(fields, 'text');
  const ctaTitle = getFieldValue(fields, 'ctaTitle');
  const ctaButton = getFieldValue(fields, 'ctaButton');

  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);

  return (
    <Container
      isMobile={isMobile}
      className='flex flex-col w-full h-auto bg-white items-center pl-6 pr-8 mb-24 md:px-0 md:my-40'
    >
      <Heading className='w-full font-trade-gothic-20 text-mattamy-blue text-4xl md:text-6xl leading-9 tracking-tighter text-center mb-1'>
        {headline}
      </Heading>

      <Text className='w-full font-graphie text-mattamy-blue text-xl leading-7 tracking-normal text-center mb-10'>
        <RichText
          tag='span'
          className='richtext'
          field={{ value: text }}
        ></RichText>
      </Text>

      <Button
        color={isMobile ? 'action-blue' : 'mattamy-blue'}
        variant={isMobile ? 'filled' : 'outlined'}
        className='text-base h-60-mattamy pt-0 pb-0 '
        href={ctaButton.href}
      >
        {ctaTitle}
      </Button>
    </Container>
  );
};

export default PageNotFound;
